const moduleData = {
    setProfile(state, data) {
        state.profile = data;
    },
    setEdus(state, data) {
        state.edus = data || [];
    },
    setWorks(state, data) {
        state.works = data || [];
    },
    setOrgs(state, data) {
        state.orgs = data || [];
    },
    setOthers(state, data) {
        state.others = data || {}
    },
    setInfos(state, data) {
        state[data.key] = data.infos || [];
    }
};
const faq = {
    setFaqOptions(state, data) {
        state.faqOptions = data || [];
    }
};

const mutations = {
    ...moduleData,
    ...faq,
    sidebarOption(state, data) {
        state.sidebarOption = data;
    },
    // 设置token
    setCvToken(state, token) {
        state.cvToken = token;
    },
    // 设置cv info
    setCvInfo(state, data) {
        state.cvInfo = data || {};
    },
    // 设置数据结构
    setList(state, data) {
        state.list = data;
    },
    // 编辑组件显示数据
    editModuleData(state, data) {
        state.editModuleData = data || {};
    },
    // 设置经历库
    setExperience(state, data) {
        state.experience = data;
    },
    // 设置检查数据
    setCheckData(state, data) {
        state.checkData = data || {};
    },
    setIsGetData(state, data) {
        state.isGetData = data;
    },
    setOnePage(state, fn) {
        state.onePage = fn;
    },
    //同步编辑/添加状态，是否是编辑/添加
    editModuleState(state, data) {
        console.log(data)
        state.editModuleState = data;
    },
    setMentor(state, fn) {
        state.mentor = fn;
    }
};
export default mutations;
